<script>
  // components
  import TwoColumnCell from './TwoColumnCell.svelte';

  /** @type {import('../types.d').CandidateFeed} */
  export let candidates;
  const [firstCandidate, secondCandidate, thirdCandidate] = candidates;
  const viewableCandidates = [firstCandidate, secondCandidate, thirdCandidate];

  //   /** @type {import('../types.d').Crosswalk} */
  // //   export let lookup;
  // //   /** @type {number} */
  // export let totalVotes;
  // export let open = false;

  /** @type {number | null} */
  export let districtNumber;
  /** @type {boolean} */
  export let isUncontested;
  /** @type {number} */
  export let eevp;
  /** @type {number} */
  export let totalVotes;
</script>

<tr class="contest__candidate-row">
  <th scope="row" class="text-center">
    {districtNumber}
  </th>
  {#each viewableCandidates as c, idx}
    {#if c}
      <TwoColumnCell
        name={c.family_name}
        party={c.party}
        votes={c.votes}
        {totalVotes}
        isWinner={c.is_winner}
        {isUncontested}
        {idx}
      />
    {:else if idx == 1}
      <td class:desktop-only={idx === 2}>-</td>
    {/if}
  {/each}
  <td class="text-right">
    {isUncontested ? 'Uncontested' : eevp}
    <span class="candidate__pct-symbol">%</span>
  </td>
</tr>
